import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Flex, Text, Icon } from 'roo-ui/components';
import range from 'lodash/range';
import pluralize from 'pluralize';

const RoomTypeDisplayMeta = React.memo(({ maxOccupantCount }) => {
  if (!maxOccupantCount) return null;

  const OccupantIcon =
    maxOccupantCount > 3 ? (
      <Icon name="people" color="greys.steel" size={18} mb="-3px" />
    ) : (
      <Fragment>
        {range(maxOccupantCount).map((i) => (
          <Icon key={i} name="person" color="greys.steel" size={18} ml="-2px" mb="-2px" />
        ))}
      </Fragment>
    );

  return (
    <Flex alignItems="center">
      {OccupantIcon}
      <Text fontSize="base" color="greys.steel" ml="2">
        Sleeps {maxOccupantCount} {pluralize('guest', maxOccupantCount)}
      </Text>
    </Flex>
  );
});

RoomTypeDisplayMeta.displayName = 'RoomTypeDisplayMeta';

RoomTypeDisplayMeta.propTypes = {
  maxOccupantCount: PropTypes.number,
};

RoomTypeDisplayMeta.defaultProps = {
  maxOccupantCount: null,
};

export default RoomTypeDisplayMeta;
